<template>
  <div class="Navigation">

    <div class="Navigation__lang" @click="$root.langSwitch()">
      {{ lang == 'en' ? 'FR' : 'EN' }}
    </div>

    <div class="Navigation__ico" @click="click()"> 

      <div class="Navigation__svg on" v-if="!narration_muted">
        <svg viewBox="0 0 14.91 8.45">
          <path class="cls-1" d="M12.23,4.6a8.19,8.19,0,0,1-1.92-.68c-.53-.24-1,0-1.88.35l-.14.06a2.7,2.7,0,0,1-1.64,0l-.43-.17c-.74-.3-1.17-.46-1.63-.25a8,8,0,0,1-1.91.68L.26,5l3.51,2.3a6.55,6.55,0,0,0,7.36,0L14.65,5Z"/>
          <path class="cls-1" d="M2.51,3.61A6.78,6.78,0,0,0,4.18,3a2.89,2.89,0,0,1,2.41.23L7,3.41a2,2,0,0,0,.88,0L8,3.36A3.13,3.13,0,0,1,10.73,3a6.64,6.64,0,0,0,1.67.6l2.51.44L11.18.64a2.24,2.24,0,0,0-3.1,0l-.63.55L6.82.61a2.23,2.23,0,0,0-3.09,0L0,4.05Z"/>
        </svg>
      </div>

      <div class="Navigation__svg off" v-if="narration_muted">
        <svg viewBox="0 0 14.91 13.18">
          <line class="cls-11" x1="1.05" y1="12.82" x2="13.52" y2="0.35"/>
          <path class="cls-2" d="M4.18,6.16a2.86,2.86,0,0,1,2.41.23L7,6.55a2,2,0,0,0,.84,0l3-3a2.24,2.24,0,0,0-2.79.21l-.63.56-.63-.56a2.23,2.23,0,0,0-3.09,0L0,7.19l2.51-.44A7.19,7.19,0,0,0,4.18,6.16Z"/>
          <path class="cls-2" d="M10.44,6.06a1.11,1.11,0,0,1,.29.1,7,7,0,0,0,1.67.59l2.51.44L12,4.52Z"/>
          <path class="cls-2" d="M3.88,10.53l3-3a1.16,1.16,0,0,1-.22-.06l-.43-.17C5.48,7,5.05,6.86,4.59,7.07a8,8,0,0,1-1.91.67L.26,8.16l3.51,2.3A1.05,1.05,0,0,1,3.88,10.53Z"/>
          <path class="cls-2" d="M10.31,7.07A1.21,1.21,0,0,0,9.49,7l-4.2,4.2a6.53,6.53,0,0,0,5.84-.75l3.52-2.3-2.42-.42A8.19,8.19,0,0,1,10.31,7.07Z"/>
        </svg>
      </div>

    </div>
    <Breadcrumb v-if="$route.meta.name == 'museum' && slugIsBefore('merci')" />
    
    <div
      class="Navigation__burger-wrapper"
      :class="[{ 'is-active': $route.params.page }]"
      @click="open">
			<span class="Navigation__burger" />
		</div>

    <transition name="Navigation__menu">
      <div class="Navigation__menu" v-if="$route.params.page">
        <div class="Navigation__menu-top" v-html="require('./svg/top-left.svg')" />
        <div class="Navigation__menu-container">
          <router-link
            activeClass="is-active"
            :key="menu.slug"
            :to="{ params: { page: menu.slug } }"
            class="Navigation__link"
            v-for="menu in trans('menu')">
            {{ menu.name }}
          </router-link>
        </div>
      </div>
    </transition>

    <transition name="Navigation__page" mode="">
      <div class="Navigation__page" :key="page" v-if="$route.params.page">
        <div class="Navigation__page-scroll">
          <Comp :is="page" />
        </div>
        <div class="Navigation__page-bottom" v-html="require('./svg/bottom-right.svg')" />
      </div>
    </transition>
  </div>
</template>

<script>
import Aventure from './pages/Aventure'
import Artists from './pages/Artists'
import Classe from './pages/Classe'
import Team from './pages/Team'
import Glossary from './pages/Glossary'
import Breadcrumb from './Breadcrumb'

export default {
  name: 'Navigation',
  components: { Aventure, Artists, Classe, Team, Breadcrumb, Glossary },
  data: () => ({
    page: null
  }),
  translations: {
    fr: {
      menu: [
        { name: "l'aventure", slug: "l-aventure", comp: 'Aventure' },
        { name: "Les artistes", slug: "les-artistes", comp: 'Artists' },
        { name: "En classe", slug: "en-classe", comp: 'Classe' },
        { name: "Glossaire", slug: "glossaire", comp: 'Glossary' },
        { name: "L'équipe", slug: "l-equipe", comp: 'Team' },
      ]
    },
    en: {
      menu: [
        { name: "The Adventure", slug: "the-adventure", comp: 'Aventure' },
        { name: "The Artists", slug: "the-artists", comp: 'Artists' },
        { name: "In the Classroom", slug: "in-the-classroom", comp: 'Classe' },
        { name: "Glossary", slug: "glossary", comp: 'Glossary' },
        { name: "The Team", slug: "the-team", comp: 'Team' },
      ]
    }
  },
  computed: { 
    narration_muted() { return this.$store.getters['app/narration_muted'] }
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {



        this.$root.commonsTranslations = {
          en: { Route: { params: this.$route.params, query: this.$route.query} },
          fr: { Route: { params: this.$route.params, query: this.$route.query} },
        }
        const page = this.$route.params.page
        if(!page) return
        let menu = _.find(this.trans('menu'), m => m.slug == this.$route.params.page)
        if(!menu)
          return this.$router.replace({ name: this.$route.name, params: { page: this.trans('menu')[0].slug } })
        this.page = menu.comp
      }
    },
  },
	methods: {
    open() {
      this.$router.push({ params: { page: this.$route.params.page ? null : this.trans('menu')[0].slug } })
    },
    click() {
      const res = !this.narration_muted
      this.$store.commit('app/NARRATION_MUTED', res)
    },
	}
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'
@import './styl/Hamburger-icon'

.Navigation
  position fixed
  top 0px
  left 0px
  right 0px
  z-index 9999999

  &__lang
    position absolute
    top 24px
    right 100px
    color white
    cursor pointer
    font-size 12px
    z-index 9999
    letter-spacing .2em
    font-weight 700

  &__burger
    hamburger-generator(30px, 4px, 5px, white, $timing-function: linear)

  &__burger-wrapper
    position absolute
    cursor pointer
    padding 25px
    z-index 2
    &.is-active
      .Navigation__burger
        hamburger-animation()

  &__menu
    position fixed
    left 0px
    top 0px
    background black
    height 100vh
    width 300px
    transition transform .5s
    font-weight 700
    font-size 12px
    letter-spacing .2em
    &-enter
    &-leave-active
      transform translateX(-300px)
    &:after
      content ''
      position absolute
      right 0px
      top 0px
      bottom 0px
      width 1px
      background linear-gradient(to bottom, grad_blue, grad_green)
    &-container
      position absolute
      top 50%
      left 20px
      transform translateY(-50%)
      text-align center

  &__link
    padding 0px 30px
    height 60px
    line-height 60px
    margin 0 auto 20px
    display inline-block
    text-transform uppercase
    font-size 16px
    position relative
    &:after
      content ' '
      position absolute
      top 0px
      left 0px
      right 0px
      bottom 0px
      background linear-gradient(to right, grad_blue, grad_green)
      opacity 0
      z-index -1
      border-radius 30px
      transition opacity 1s, transform .5s
      transform scale(.6)
    &.is-active
      &:after
        opacity 1
        transform scale(1)

  &__page
    position fixed
    left 300px
    top 0px
    right 0px
    height 100vh
    background black
    transition transform .5s, opacity 1s
    font-size 16px
    line-height 22px
    &-enter
      transform translateX(100%)
    &-leave-active
      transform scale(.9)
      opacity 0
    &-scroll
      position absolute
      top 0px
      right 0px
      bottom 0px
      left 0px
      padding-top 100px
      overflow-y auto
      z-index 1
    &-bottom
      position fixed
      bottom 0px
      right 0px
      width 300px
      height 300px
    h1
      font-size 28px
      margin 40px 0 20px
      line-height 34px
      font-weight 500
    h2
      font-size 24px
      line-height 30px
      font-weight 500
    h3
      font-size 14px
      line-height 26px
      text-transform uppercase
      font-weight 300
      letter-spacing 1px
      margin-bottom 5px

    ul
      padding 20px 0 20px 20px
      li
        list-style disc
        margin-bottom 10px

  &__ico
    position absolute
    top 23px
    right 65px
    cursor pointer

  &__svg
    width 19px
    
    &.off
      padding-top 2px

  .cls-1
    fill #f4f4f4

  .cls-11
    fill none
    stroke #f4f4f4
    stroke-miterlimit 10
  .cls-2
    fill #f4f4f4

</style>



// WEBPACK FOOTER //
// src/components/navigation/Navigation.vue